/**
 * ReactionBar — Display reactions under a message + quick-react picker
 */

import { useState, memo } from "react";
import styles from "./ReactionBar.module.css";

export interface ReactionGroup {
  emoji: string;
  count: number;
  userReacted: boolean;
}

interface ReactionBarProps {
  reactions: ReactionGroup[];
  onToggle: (emoji: string) => void;
}

const QUICK_EMOJIS = ["👍", "❤️", "😂", "😮", "😢", "🔥", "👏", "🎉"];

export const ReactionBar = memo(function ReactionBar({ reactions, onToggle }: ReactionBarProps) {
  const [showPicker, setShowPicker] = useState(false);

  return (
    <div className={styles.container}>
      {/* Existing reactions */}
      {reactions.map((r) => (
        <button
          key={r.emoji}
          className={`${styles.reaction} ${r.userReacted ? styles.reacted : ""}`}
          onClick={() => onToggle(r.emoji)}
          title={`${r.emoji} (${r.count})`}
        >
          <span className={styles.emoji}>{r.emoji}</span>
          <span className={styles.count}>{r.count}</span>
        </button>
      ))}

      {/* Add reaction button */}
      <div className={styles.addWrapper}>
        <button
          className={styles.addBtn}
          onClick={() => setShowPicker(!showPicker)}
          title="Reaktion hinzufügen"
        >
          😊+
        </button>

        {showPicker && (
          <div className={styles.picker}>
            {QUICK_EMOJIS.map((emoji) => (
              <button
                key={emoji}
                className={styles.pickerEmoji}
                onClick={() => {
                  onToggle(emoji);
                  setShowPicker(false);
                }}
              >
                {emoji}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
});
